export const DOMAINS = {
  STAGING: 'squareupstaging.com',
  PRODUCTION: 'squareup.com',
};
